import { areAllFieldsValid } from './areAllFieldsValid'
import { ValidationResult } from '../../../@types/validation-types'

export const checkValidity = (validationMessages: ValidationResult, hasValidGeoCoordinates: boolean) =>
  areAllFieldsValid(validationMessages) &&
  (hasValidGeoCoordinates ||
    (!validationMessages.address.fields?.manualRegion?.length &&
      !validationMessages.address.fields?.manualCity?.length &&
      !validationMessages.address.fields?.manualQuarter?.length))
